import {
  EngagementLookbookWithUser,
  LookbookResponseDto,
} from '@epicuro-next/data/engagement/engagement-models';
import { IUser } from '@epicuro-next/data/users';
// tslint:disable-next-line:nx-enforce-module-boundaries
import { UserEntity } from '@epicuro-next/state/user-entities';
import { decode } from 'html-entities';

import {
  mapEngagementListOwner,
  mapEngagementListToLegacy,
} from '../engagement-list-mappers/engagement-list-mappers';

// When delete mapping - move decode logic to other place (map in service response)
export function mapEngagementLookbookToLegacy(
  engagementLookbook: LookbookResponseDto,
  userEntities: UserEntity[],
): EngagementLookbookWithUser {
  const ownerId = engagementLookbook.createdByUserId;
  const userEntity = userEntities.find(
    (e) => e.userExternalId === ownerId,
  )?.user;
  const owner = mapEngagementListOwner(userEntity);

  return {
    ...engagementLookbook,
    title: decode(engagementLookbook.title),
    creation: {
      dateUtc: engagementLookbook.createdAtUtc?.toString() ?? '',
      user: owner as unknown as IUser,
    },
    items: engagementLookbook.items.map((item) => ({
      ...item,
      productList: mapEngagementListToLegacy(item.productList, userEntities),
    })),
  };
}

export function mapEngagementLookbooksToLegacy(
  engagementLookbooks: LookbookResponseDto[],
  userEntities: UserEntity[],
) {
  return engagementLookbooks.reduce((lookBooksWithUser, lookBook) => {
    const {
      createdAtUtc: createdAt,
      updatedAtUtc: updatedAt,
      ...lookBookItem
    } = lookBook;
    const transformLookBookItem = { ...lookBookItem, createdAt, updatedAt };

    const lookBookWithUser = mapEngagementLookbookToLegacy(
      transformLookBookItem,
      userEntities,
    );
    return [...lookBooksWithUser, lookBookWithUser];
  }, [] as EngagementLookbookWithUser[]);
}
